export enum BrokerActionType {
    ViewEditBroker = 0,
    DeleteIncompleteRegisteredBroker = 1,
    SendPasswordResetEmail = 2,
}
